import React,{useState,useContext} from 'react';

import {Row,Col,Form,Button, Alert, ProgressBar} from 'react-bootstrap';

import UserContext from './../contexts/UserContext';

import _ from 'lodash';

import Utils from './../Utils';

const EditProfile = (props) => {

  const {userData, saveProfile} = useContext(UserContext);

  const [saving,setSaving] = useState(false);

  const onEditProfile = (e) => {

    var frm = e.currentTarget;
    e.preventDefault();

    var values = {};

    if(_.get(frm,'mobile.value',false)){
      values["mobile"]=frm.mobile.value;
    }
    if(_.get(frm,'address.value',false)){
      values["address"]=frm.address.value;
    }
    if(_.get(frm,'country.value',false)){
      values["country"]=frm.country.value;
    }
    if(_.get(frm, 'company_nm.value', false)){
      values["company_nm"] = frm.company_nm.value;
    }
    setSaving(true);

    saveProfile(values, (success,message) => {
      setSaving(false);
      if(!success){
        window.alert(message);
      }else{
        if(_.get(props,'onSave',false)){
          props.onSave();
        }      
      }
    } );

    return false;

  };

  const renderForm = () => <Form onSubmit={onEditProfile} className="text-left">    
    {_.isEmpty(userData.mobile) && <Row className="mt-2">
      <Col>
        <Form.Label>Enter your Phone Number * </Form.Label>
        <Form.Control type="text" name="mobile" required />
      </Col>
    </Row>}
    {_.isEmpty(userData.company_nm) && <Row className="mt-2">
      <Col>
        <Form.Label>Enter your Company Name *</Form.Label>
        <Form.Control type="text" name="company_nm" required />
      </Col>
    </Row>
    }
    {_.isEmpty(userData.address) && <Row className="mt-2">
      <Col>
        <Form.Label>Enter your address * </Form.Label>
        <Form.Control as="textarea" name="address" required />
      </Col>
    </Row>}
    {_.isEmpty(userData.country) && <Row className="mt-2">      
      <Col>
        <Form.Label>Select your Country * </Form.Label>
        <Form.Control as="select" name="country" required>
          <option value="" selected>Select Country</option>
          {Utils.countries.map(c => <option key={c} value={c}>{c}</option>)}
        </Form.Control>
      </Col>
    </Row>}
    <Row className="mt-4 text-center">
      <Col>        
        <Button type="submit" className="active px-5 py-2">Continue</Button>
      </Col>
    </Row>
  </Form>;

  return <>
    {saving && <Alert variant="warning">Saving your profile..<br /><ProgressBar className="mt-2" animated variant="primary" now={100} /></Alert>}
    {!saving && renderForm()}
  </>
};

export default EditProfile;

